export default {
    data() {
        return {
            city: [{
                    id: 1,
                    name: "基隆市",
                    area: [{
                            id: 1,
                            name: "仁愛區"
                        },
                        {
                            id: 2,
                            name: "中正區"
                        },
                        {
                            id: 3,
                            name: "信義區"
                        },
                        {
                            id: 4,
                            name: "中山區"
                        },
                        {
                            id: 5,
                            name: "安樂區"
                        },
                        {
                            id: 6,
                            name: "暖暖區"
                        },
                        {
                            id: 7,
                            name: "七堵區"
                        },
                    ]
                },
                {
                    id: 2,
                    name: "臺北市",
                    area: [{
                            id: 1,
                            name: "中正區"
                        },
                        {
                            id: 2,
                            name: "大同區"
                        },
                        {
                            id: 3,
                            name: "中山區"
                        },
                        {
                            id: 4,
                            name: "松山區"
                        },
                        {
                            id: 5,
                            name: "大安區"
                        },
                        {
                            id: 6,
                            name: "萬華區"
                        },
                        {
                            id: 7,
                            name: "信義區"
                        },
                        {
                            id: 8,
                            name: "士林區"
                        },
                        {
                            id: 9,
                            name: "北投區"
                        },
                        {
                            id: 10,
                            name: "內湖區"
                        },
                        {
                            id: 11,
                            name: "南港區"
                        },
                        {
                            id: 12,
                            name: "文山區"
                        },
                    ]
                },
                {
                    id: 3,
                    name: "新北市",
                    area: [{
                            id: 1,
                            name: "板橋區"
                        },
                        {
                            id: 2,
                            name: "新莊區"
                        },
                        {
                            id: 3,
                            name: "中和區"
                        },
                        {
                            id: 4,
                            name: "永和區"
                        },
                        {
                            id: 5,
                            name: "土城區"
                        },
                        {
                            id: 6,
                            name: "樹林區"
                        },
                        {
                            id: 7,
                            name: "三峽區"
                        },
                        {
                            id: 8,
                            name: "鶯歌區"
                        },
                        {
                            id: 9,
                            name: "三重區"
                        },
                        {
                            id: 10,
                            name: "蘆洲區"
                        },
                        {
                            id: 11,
                            name: "五股區"
                        },
                        {
                            id: 12,
                            name: "泰山區"
                        },
                        {
                            id: 13,
                            name: "林口區"
                        },
                        {
                            id: 14,
                            name: "八里區"
                        },
                        {
                            id: 15,
                            name: "淡水區"
                        },
                        {
                            id: 16,
                            name: "三芝區"
                        },
                        {
                            id: 17,
                            name: "石門區"
                        },
                        {
                            id: 18,
                            name: "金山區"
                        },
                        {
                            id: 19,
                            name: "萬里區"
                        },
                        {
                            id: 20,
                            name: "汐止區"
                        },
                        {
                            id: 21,
                            name: "瑞芳區"
                        },
                        {
                            id: 22,
                            name: "貢寮區"
                        },
                        {
                            id: 23,
                            name: "平溪區"
                        },
                        {
                            id: 24,
                            name: "雙溪區"
                        },
                        {
                            id: 25,
                            name: "新店區"
                        },
                        {
                            id: 26,
                            name: "深坑區"
                        },
                        {
                            id: 27,
                            name: "石碇區"
                        },
                        {
                            id: 28,
                            name: "坪林區"
                        },
                        {
                            id: 29,
                            name: "烏來區"
                        },
                    ]
                },
                {
                    id: 4,
                    name: "桃園市",
                    area: [{
                            id: 1,
                            name: "桃園區"
                        },
                        {
                            id: 2,
                            name: "中壢區"
                        },
                        {
                            id: 3,
                            name: "平鎮區"
                        },
                        {
                            id: 4,
                            name: "八德區"
                        },
                        {
                            id: 5,
                            name: "楊梅區"
                        },
                        {
                            id: 6,
                            name: "蘆竹區"
                        },
                        {
                            id: 7,
                            name: "大溪區"
                        },
                        {
                            id: 8,
                            name: "龍潭區"
                        },
                        {
                            id: 9,
                            name: "龜山區"
                        },
                        {
                            id: 10,
                            name: "大園區"
                        },
                        {
                            id: 11,
                            name: "觀音區"
                        },
                        {
                            id: 12,
                            name: "新屋區"
                        },
                        {
                            id: 13,
                            name: "復興區"
                        },
                    ]
                },

                {
                    id: 5,
                    name: "新竹市",
                    area: [{
                            id: 1,
                            name: "東區"
                        },
                        {
                            id: 2,
                            name: "北區"
                        },
                        {
                            id: 3,
                            name: "香山區"
                        },
                    ]
                },
                {
                    id: 6,
                    name: "新竹縣",
                    area: [{
                            id: 1,
                            name: "竹北市"
                        },
                        {
                            id: 2,
                            name: "竹東鎮"
                        },
                        {
                            id: 3,
                            name: "新埔鎮"
                        },
                        {
                            id: 4,
                            name: "關西鎮"
                        },
                        {
                            id: 5,
                            name: "湖口鄉"
                        },
                        {
                            id: 6,
                            name: "新豐鄉"
                        },
                        {
                            id: 7,
                            name: "峨眉鄉"
                        },
                        {
                            id: 8,
                            name: "寶山鄉"
                        },
                        {
                            id: 9,
                            name: "北埔鄉"
                        },
                        {
                            id: 10,
                            name: "芎林鄉"
                        },
                        {
                            id: 11,
                            name: "橫山鄉"
                        },
                        {
                            id: 12,
                            name: "尖石鄉"
                        },
                        {
                            id: 13,
                            name: "五峰鄉"
                        },
                    ]
                },
                {
                    id: 7,
                    name: "苗栗縣",
                    area: [{
                            id: 1,
                            name: "苗栗市"
                        },
                        {
                            id: 2,
                            name: "頭份市"
                        },
                        {
                            id: 3,
                            name: "竹南鎮"
                        },
                        {
                            id: 4,
                            name: "後龍鎮"
                        },
                        {
                            id: 5,
                            name: "通霄鎮"
                        },
                        {
                            id: 6,
                            name: "苑裡鎮"
                        },
                        {
                            id: 7,
                            name: "卓蘭鎮"
                        },
                        {
                            id: 8,
                            name: "造橋鄉"
                        },
                        {
                            id: 9,
                            name: "西湖鄉"
                        },
                        {
                            id: 10,
                            name: "頭屋鄉"
                        },
                        {
                            id: 11,
                            name: "公館鄉"
                        },
                        {
                            id: 12,
                            name: "銅鑼鄉"
                        },
                        {
                            id: 13,
                            name: "三義鄉"
                        },
                        {
                            id: 14,
                            name: "大湖鄉"
                        },
                        {
                            id: 15,
                            name: "獅潭鄉"
                        },
                        {
                            id: 16,
                            name: "三灣鄉"
                        },
                        {
                            id: 17,
                            name: "南庄鄉"
                        },
                        {
                            id: 18,
                            name: "泰安鄉"
                        },
                    ]
                },
                {
                    id: 8,
                    name: "臺中市",
                    area: [{
                            id: 1,
                            name: "中區"
                        },
                        {
                            id: 2,
                            name: "東區"
                        },
                        {
                            id: 3,
                            name: "南區"
                        },
                        {
                            id: 4,
                            name: "西區"
                        },
                        {
                            id: 5,
                            name: "北區"
                        },
                        {
                            id: 6,
                            name: "北屯區"
                        },
                        {
                            id: 7,
                            name: "西屯區"
                        },
                        {
                            id: 8,
                            name: "南屯區"
                        },
                        {
                            id: 9,
                            name: "太平區"
                        },
                        {
                            id: 10,
                            name: "大里區"
                        },
                        {
                            id: 11,
                            name: "霧峰區"
                        },
                        {
                            id: 12,
                            name: "烏日區"
                        },
                        {
                            id: 13,
                            name: "豐原區"
                        },
                        {
                            id: 14,
                            name: "后里區"
                        },
                        {
                            id: 15,
                            name: "石岡區"
                        },
                        {
                            id: 16,
                            name: "東勢區"
                        },
                        {
                            id: 17,
                            name: "新社區"
                        },
                        {
                            id: 18,
                            name: "潭子區"
                        },
                        {
                            id: 19,
                            name: "大雅區"
                        },
                        {
                            id: 20,
                            name: "神岡區"
                        },
                        {
                            id: 21,
                            name: "大肚區"
                        },
                        {
                            id: 22,
                            name: "沙鹿區"
                        },
                        {
                            id: 23,
                            name: "龍井區"
                        },
                        {
                            id: 24,
                            name: "梧棲區"
                        },
                        {
                            id: 25,
                            name: "清水區"
                        },
                        {
                            id: 26,
                            name: "大甲區"
                        },
                        {
                            id: 27,
                            name: "外埔區"
                        },
                        {
                            id: 28,
                            name: "大安區"
                        },
                        {
                            id: 29,
                            name: "和平區"
                        },
                    ]
                },
                {
                    id: 9,
                    name: "彰化縣",
                    area: [{
                            id: 1,
                            name: "彰化市"
                        },
                        {
                            id: 2,
                            name: "員林市"
                        },
                        {
                            id: 3,
                            name: "和美鎮"
                        },
                        {
                            id: 4,
                            name: "鹿港鎮"
                        },
                        {
                            id: 5,
                            name: "溪湖鎮"
                        },
                        {
                            id: 6,
                            name: "二林鎮"
                        },
                        {
                            id: 7,
                            name: "田中鎮"
                        },
                        {
                            id: 8,
                            name: "北斗鎮"
                        },
                        {
                            id: 9,
                            name: "花壇鄉"
                        },
                        {
                            id: 10,
                            name: "芬園鄉"
                        },
                        {
                            id: 11,
                            name: "大村鄉"
                        },
                        {
                            id: 12,
                            name: "永靖鄉"
                        },
                        {
                            id: 13,
                            name: "伸港鄉"
                        },
                        {
                            id: 14,
                            name: "線西鄉"
                        },
                        {
                            id: 15,
                            name: "福興鄉"
                        },
                        {
                            id: 16,
                            name: "秀水鄉"
                        },
                        {
                            id: 17,
                            name: "埔心鄉"
                        },
                        {
                            id: 18,
                            name: "埔鹽鄉"
                        },
                        {
                            id: 19,
                            name: "大城鄉"
                        },
                        {
                            id: 20,
                            name: "芳苑鄉"
                        },
                        {
                            id: 21,
                            name: "竹塘鄉"
                        },
                        {
                            id: 22,
                            name: "社頭鄉"
                        },
                        {
                            id: 23,
                            name: "二水鄉"
                        },
                        {
                            id: 24,
                            name: "田尾鄉"
                        },
                        {
                            id: 25,
                            name: "埤頭鄉"
                        },
                        {
                            id: 26,
                            name: "溪州鄉"
                        },
                    ]
                },
                {
                    id: 10,
                    name: "南投縣",
                    area: [{
                            id: 1,
                            name: "南投市"
                        },
                        {
                            id: 2,
                            name: "埔里鎮"
                        },
                        {
                            id: 3,
                            name: "草屯鎮"
                        },
                        {
                            id: 4,
                            name: "竹山鎮"
                        },
                        {
                            id: 5,
                            name: "集集鎮"
                        },
                        {
                            id: 6,
                            name: "名間鄉"
                        },
                        {
                            id: 7,
                            name: "鹿谷鄉"
                        },
                        {
                            id: 8,
                            name: "中寮鄉"
                        },
                        {
                            id: 9,
                            name: "魚池鄉"
                        },
                        {
                            id: 10,
                            name: "國姓鄉"
                        },
                        {
                            id: 11,
                            name: "水里鄉"
                        },
                        {
                            id: 12,
                            name: "信義鄉"
                        },
                        {
                            id: 13,
                            name: "仁愛鄉"
                        },
                    ]
                },
                {
                    id: 11,
                    name: "雲林縣",
                    area: [{
                            id: 1,
                            name: "斗六市"
                        },
                        {
                            id: 2,
                            name: "斗南鎮"
                        },
                        {
                            id: 3,
                            name: "虎尾鎮"
                        },
                        {
                            id: 4,
                            name: "西螺鎮"
                        },
                        {
                            id: 5,
                            name: "土庫鎮"
                        },
                        {
                            id: 6,
                            name: "北港鎮"
                        },
                        {
                            id: 7,
                            name: "林內鄉"
                        },
                        {
                            id: 8,
                            name: "古坑鄉"
                        },
                        {
                            id: 9,
                            name: "大埤鄉"
                        },
                        {
                            id: 10,
                            name: "莿桐鄉"
                        },
                        {
                            id: 11,
                            name: "褒忠鄉"
                        },
                        {
                            id: 12,
                            name: "二崙鄉"
                        },
                        {
                            id: 13,
                            name: "崙背鄉"
                        },
                        {
                            id: 14,
                            name: "麥寮鄉"
                        },
                        {
                            id: 15,
                            name: "台西鄉"
                        },
                        {
                            id: 16,
                            name: "東勢鄉"
                        },
                        {
                            id: 17,
                            name: "元長鄉"
                        },
                        {
                            id: 18,
                            name: "四湖鄉"
                        },
                        {
                            id: 19,
                            name: "口湖鄉"
                        },
                        {
                            id: 20,
                            name: "水林鄉"
                        },
                    ]
                },
                {
                    id: 12,
                    name: "嘉義市",
                    area: [{
                            id: 1,
                            name: "東區"
                        },
                        {
                            id: 2,
                            name: "西區"
                        },
                    ]
                },
                {
                    id: 13,
                    name: "嘉義縣",
                    area: [{
                            id: 1,
                            name: "太保市"
                        },
                        {
                            id: 2,
                            name: "朴子市"
                        },
                        {
                            id: 3,
                            name: "布袋鎮"
                        },
                        {
                            id: 4,
                            name: "大林鎮"
                        },
                        {
                            id: 5,
                            name: "民雄鄉"
                        },
                        {
                            id: 6,
                            name: "溪口鄉"
                        },
                        {
                            id: 7,
                            name: "新港鄉"
                        },
                        {
                            id: 8,
                            name: "六腳鄉"
                        },
                        {
                            id: 9,
                            name: "東石鄉"
                        },
                        {
                            id: 10,
                            name: "義竹鄉"
                        },
                        {
                            id: 11,
                            name: "鹿草鄉"
                        },
                        {
                            id: 12,
                            name: "水上鄉"
                        },
                        {
                            id: 13,
                            name: "中埔鄉"
                        },
                        {
                            id: 14,
                            name: "竹崎鄉"
                        },
                        {
                            id: 15,
                            name: "梅山鄉"
                        },
                        {
                            id: 16,
                            name: "番路鄉"
                        },
                        {
                            id: 17,
                            name: "大埔鄉"
                        },
                        {
                            id: 18,
                            name: "阿里山鄉"
                        },
                    ]
                },
                {
                    id: 14,
                    name: "台南市",
                    area: [{
                            id: 1,
                            name: "中西區"
                        },
                        {
                            id: 2,
                            name: "東區"
                        },
                        {
                            id: 3,
                            name: "南區"
                        },
                        {
                            id: 4,
                            name: "北區"
                        },
                        {
                            id: 5,
                            name: "安平區"
                        },
                        {
                            id: 6,
                            name: "安南區"
                        },
                        {
                            id: 7,
                            name: "永康區"
                        },
                        {
                            id: 8,
                            name: "歸仁區"
                        },
                        {
                            id: 9,
                            name: "新化區"
                        },
                        {
                            id: 10,
                            name: "左鎮區"
                        },
                        {
                            id: 11,
                            name: "玉井區"
                        },
                        {
                            id: 12,
                            name: "楠西區"
                        },
                        {
                            id: 13,
                            name: "南化區"
                        },
                        {
                            id: 14,
                            name: "仁德區"
                        },
                        {
                            id: 15,
                            name: "關廟區"
                        },
                        {
                            id: 16,
                            name: "龍崎區"
                        },
                        {
                            id: 17,
                            name: "官田區"
                        },
                        {
                            id: 18,
                            name: "麻豆區"
                        },
                        {
                            id: 19,
                            name: "佳里區"
                        },
                        {
                            id: 20,
                            name: "西港區"
                        },
                        {
                            id: 21,
                            name: "七股區"
                        },
                        {
                            id: 22,
                            name: "將軍區"
                        },
                        {
                            id: 23,
                            name: "學甲區"
                        },
                        {
                            id: 24,
                            name: "北門區"
                        },
                        {
                            id: 25,
                            name: "新營區"
                        },
                        {
                            id: 26,
                            name: "後壁區"
                        },
                        {
                            id: 27,
                            name: "白河區"
                        },
                        {
                            id: 28,
                            name: "東山區"
                        },
                        {
                            id: 29,
                            name: "六甲區"
                        },
                        {
                            id: 30,
                            name: "下營區"
                        },
                        {
                            id: 31,
                            name: "柳營區"
                        },
                        {
                            id: 32,
                            name: "鹽水區"
                        },
                        {
                            id: 33,
                            name: "善化區"
                        },
                        {
                            id: 34,
                            name: "大內區"
                        },
                        {
                            id: 35,
                            name: "山上區"
                        },
                        {
                            id: 36,
                            name: "新市區"
                        },
                        {
                            id: 37,
                            name: "安定區"
                        },
                    ]
                },
                {
                    id: 15,
                    name: "高雄市",
                    area: [{
                            id: 1,
                            name: "楠梓區"
                        },
                        {
                            id: 2,
                            name: "左營區"
                        },
                        {
                            id: 3,
                            name: "鼓山區"
                        },
                        {
                            id: 4,
                            name: "三民區"
                        },
                        {
                            id: 5,
                            name: "鹽埕區"
                        },
                        {
                            id: 6,
                            name: "前金區"
                        },
                        {
                            id: 7,
                            name: "新興區"
                        },
                        {
                            id: 8,
                            name: "苓雅區"
                        },
                        {
                            id: 9,
                            name: "前鎮區"
                        },
                        {
                            id: 10,
                            name: "旗津區"
                        },
                        {
                            id: 11,
                            name: "小港區"
                        },
                        {
                            id: 12,
                            name: "鳳山區"
                        },
                        {
                            id: 13,
                            name: "大寮區"
                        },
                        {
                            id: 14,
                            name: "鳥松區"
                        },
                        {
                            id: 15,
                            name: "林園區"
                        },
                        {
                            id: 16,
                            name: "仁武區"
                        },
                        {
                            id: 17,
                            name: "大樹區"
                        },
                        {
                            id: 18,
                            name: "大社區"
                        },
                        {
                            id: 19,
                            name: "岡山區"
                        },
                        {
                            id: 20,
                            name: "路竹區"
                        },
                        {
                            id: 21,
                            name: "橋頭區"
                        },
                        {
                            id: 22,
                            name: "梓官區"
                        },
                        {
                            id: 23,
                            name: "彌陀區"
                        },
                        {
                            id: 24,
                            name: "永安區"
                        },
                        {
                            id: 25,
                            name: "燕巢區"
                        },
                        {
                            id: 26,
                            name: "田寮區"
                        },
                        {
                            id: 27,
                            name: "阿蓮區"
                        },
                        {
                            id: 28,
                            name: "茄萣區"
                        },
                        {
                            id: 29,
                            name: "湖內區"
                        },
                        {
                            id: 30,
                            name: "旗山區"
                        },
                        {
                            id: 31,
                            name: "美濃區"
                        },
                        {
                            id: 32,
                            name: "內門區"
                        },
                        {
                            id: 33,
                            name: "杉林區"
                        },
                        {
                            id: 34,
                            name: "甲仙區"
                        },
                        {
                            id: 35,
                            name: "六龜區"
                        },
                        {
                            id: 36,
                            name: "茂林區"
                        },
                        {
                            id: 37,
                            name: "桃源區"
                        },
                        {
                            id: 38,
                            name: "那瑪夏區"
                        },
                    ]
                },
                {
                    id: 16,
                    name: "屏東縣",
                    area: [{
                            id: 1,
                            name: "屏東市"
                        },
                        {
                            id: 2,
                            name: "潮州鎮"
                        },
                        {
                            id: 3,
                            name: "東港鎮"
                        },
                        {
                            id: 4,
                            name: "恆春鎮"
                        },
                        {
                            id: 5,
                            name: "萬丹鄉"
                        },
                        {
                            id: 6,
                            name: "長治鄉"
                        },
                        {
                            id: 7,
                            name: "麟洛鄉"
                        },
                        {
                            id: 8,
                            name: "九如鄉"
                        },
                        {
                            id: 9,
                            name: "里港鄉"
                        },
                        {
                            id: 10,
                            name: "鹽埔鄉"
                        },
                        {
                            id: 11,
                            name: "高樹鄉"
                        },
                        {
                            id: 12,
                            name: "萬巒鄉"
                        },
                        {
                            id: 13,
                            name: "內埔鄉"
                        },
                        {
                            id: 14,
                            name: "竹田鄉"
                        },
                        {
                            id: 15,
                            name: "新埤鄉"
                        },
                        {
                            id: 16,
                            name: "枋寮鄉"
                        },
                        {
                            id: 17,
                            name: "新園鄉"
                        },
                        {
                            id: 18,
                            name: "崁頂鄉"
                        },
                        {
                            id: 19,
                            name: "林邊鄉"
                        },
                        {
                            id: 20,
                            name: "南州鄉"
                        },
                        {
                            id: 21,
                            name: "佳冬鄉"
                        },
                        {
                            id: 22,
                            name: "琉球鄉"
                        },
                        {
                            id: 23,
                            name: "車城鄉"
                        },
                        {
                            id: 24,
                            name: "滿州鄉"
                        },
                        {
                            id: 25,
                            name: "枋山鄉"
                        },
                        {
                            id: 26,
                            name: "霧臺鄉"
                        },
                        {
                            id: 27,
                            name: "瑪家鄉"
                        },
                        {
                            id: 28,
                            name: "泰武鄉"
                        },
                        {
                            id: 29,
                            name: "來義鄉"
                        },
                        {
                            id: 30,
                            name: "春日鄉"
                        },
                        {
                            id: 31,
                            name: "獅子鄉"
                        },
                        {
                            id: 32,
                            name: "牡丹鄉"
                        },
                        {
                            id: 33,
                            name: "三地門鄉"
                        },
                    ]
                },
                {
                    id: 17,
                    name: "宜蘭縣",
                    area: [{
                            id: 1,
                            name: "宜蘭市"
                        },
                        {
                            id: 2,
                            name: "頭城鎮"
                        },
                        {
                            id: 3,
                            name: "羅東鎮"
                        },
                        {
                            id: 4,
                            name: "蘇澳鎮"
                        },
                        {
                            id: 5,
                            name: "礁溪鄉"
                        },
                        {
                            id: 6,
                            name: "壯圍鄉"
                        },
                        {
                            id: 7,
                            name: "員山鄉"
                        },
                        {
                            id: 8,
                            name: "冬山鄉"
                        },
                        {
                            id: 9,
                            name: "五結鄉"
                        },
                        {
                            id: 10,
                            name: "三星鄉"
                        },
                        {
                            id: 11,
                            name: "大同鄉"
                        },
                        {
                            id: 12,
                            name: "南澳鄉"
                        },
                    ]
                },
                {
                    id: 18,
                    name: "花蓮縣",
                    area: [{
                            id: 1,
                            name: "花蓮市"
                        },
                        {
                            id: 2,
                            name: "鳳林鎮"
                        },
                        {
                            id: 3,
                            name: "玉里鎮"
                        },
                        {
                            id: 4,
                            name: "新城鄉"
                        },
                        {
                            id: 5,
                            name: "吉安鄉"
                        },
                        {
                            id: 6,
                            name: "壽豐鄉"
                        },
                        {
                            id: 7,
                            name: "光復鄉"
                        },
                        {
                            id: 8,
                            name: "豐濱鄉"
                        },
                        {
                            id: 9,
                            name: "瑞穗鄉"
                        },
                        {
                            id: 10,
                            name: "富里鄉"
                        },
                        {
                            id: 11,
                            name: "秀林鄉"
                        },
                        {
                            id: 12,
                            name: "萬榮鄉"
                        },
                        {
                            id: 13,
                            name: "卓溪鄉"
                        },
                    ]
                },
                {
                    id: 19,
                    name: "臺東縣",
                    area: [{
                            id: 1,
                            name: "臺東市"
                        },
                        {
                            id: 2,
                            name: "成功鎮"
                        },
                        {
                            id: 3,
                            name: "關山鎮"
                        },
                        {
                            id: 4,
                            name: "長濱鄉"
                        },
                        {
                            id: 5,
                            name: "池上鄉"
                        },
                        {
                            id: 6,
                            name: "東河鄉"
                        },
                        {
                            id: 7,
                            name: "鹿野鄉"
                        },
                        {
                            id: 8,
                            name: "卑南鄉"
                        },
                        {
                            id: 9,
                            name: "大武鄉"
                        },
                        {
                            id: 10,
                            name: "綠島鄉"
                        },
                        {
                            id: 11,
                            name: "太麻里鄉"
                        },
                        {
                            id: 12,
                            name: "海端鄉"
                        },
                        {
                            id: 13,
                            name: "延平鄉"
                        },
                        {
                            id: 14,
                            name: "金峰鄉"
                        },
                        {
                            id: 15,
                            name: "達仁鄉"
                        },
                        {
                            id: 16,
                            name: "蘭嶼鄉"
                        },
                    ]
                },
                {
                    id: 20,
                    name: "澎湖縣",
                    area: [{
                            id: 1,
                            name: "馬公市"
                        },
                        {
                            id: 2,
                            name: "湖西鄉"
                        },
                        {
                            id: 3,
                            name: "白沙鄉"
                        },
                        {
                            id: 4,
                            name: "西嶼鄉"
                        },
                        {
                            id: 5,
                            name: "望安鄉"
                        },
                        {
                            id: 6,
                            name: "七美鄉"
                        },
                    ]
                },
                {
                    id: 21,
                    name: "金門縣",
                    area: [{
                            id: 1,
                            name: "金城鎮"
                        },
                        {
                            id: 2,
                            name: "金湖鎮"
                        },
                        {
                            id: 3,
                            name: "金沙鎮"
                        },
                        {
                            id: 4,
                            name: "金寧鄉"
                        },
                        {
                            id: 5,
                            name: "烈嶼鄉"
                        },
                        {
                            id: 6,
                            name: "烏坵鄉"
                        },
                    ]
                },
                {
                    id: 22,
                    name: "連江縣",
                    area: [{
                            id: 1,
                            name: "南竿鄉"
                        },
                        {
                            id: 2,
                            name: "北竿鄉"
                        },
                        {
                            id: 3,
                            name: "莒光鄉"
                        },
                        {
                            id: 4,
                            name: "東引鄉"
                        },
                    ]
                }
            ],
        }
    },
    methods: {
        CityFilter(choosen_city) {
            return this.city.filter(city_item => {
                return city_item.id == choosen_city
            })[0].area
        },
        CityConvert(city_id, area_id) {
            let choosen_city = this.city.filter(city_item => {
                return city_item.id == city_id
            })[0]
            let choosen_area = choosen_city.area.filter(area_item => {
                return area_item.id == area_id
            })[0]
            return [choosen_city.name, choosen_area.name]
        },
        CheckAddressInclude(address, data) {
            if (data.indexOf("臺") != -1 || data.indexOf("台") != -1) {
                return address.indexOf(data.replace("台", "臺")) != -1 || address.indexOf(data.replace("臺", "台")) != -1
            } else {
                return address.indexOf(data) != -1
            }
        }
    }
};